// Appel des routes v2 du module Prévisions & Performance (backend : previsionPerformanceV2Route.js).
// Renvoie le corps de la réponse quand success est vrai, sinon null (l'appelant affiche l'erreur).
const axios = require("axios");
import * as JwtService from "@/common/jwt.service";
import { randomString, currencyFormatDE } from "@/allfunction";

export async function appelPP(store, route, corps) {
    const url = process.env.VUE_APP_API_URL + `/previsionperformance/${route}/${store.state.appsociete}/${randomString()}`;
    const res = await axios.post(url, corps || {}, {
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${JwtService.getToken()}`,
            'csrftoken': store.state.appsociete
        },
        withCredentials: true
    });
    return res.data && res.data.success ? res.data : null;
}

// Montant : « 1 250 000 FCFA » ; null = inconnu (aucun prix d'achat sur la période).
export const montant = (v) => (v === null || v === undefined ? "n.d." : currencyFormatDE(v));
// Montant court pour les axes et les cartes : « 1,2 M », « 350 k ».
export const montantCourt = (v) => {
    const n = Number(v) || 0, a = Math.abs(n);
    if (a >= 1e6) return (n / 1e6).toFixed(1).replace(".", ",") + " M";
    if (a >= 1e3) return Math.round(n / 1e3) + " k";
    return String(Math.round(n));
};
export const pourcent = (v, d = 0) => (v === null || v === undefined ? "n.d." : (v * 100).toFixed(d).replace(".", ",") + " %");
export const MOIS_COURTS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
